package com.essntl.features.customfields.ui

import com.essntl.features.customfields.domain.model.CustomFieldsModel
import com.essntl.features.organization.domain.model.OrganizationModel

interface CustomFieldsEvent {
    data class SetType(
        val type: OrganizationModel.Type,
        val contactId: String? = null,
    ) : CustomFieldsEvent

    data class UpdateCustomFields(val customFields: CustomFieldsModel) : CustomFieldsEvent
    data class AddEditCustomFields(val contactId: String) : CustomFieldsEvent
    data object ClearCustomFieldsState : CustomFieldsEvent
    data object ClearSuccessState : CustomFieldsEvent
    data class GetTravelAgent(
        val contactId: String,
    ) : CustomFieldsEvent
}